import { Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { Dot } from '@portals/icons';
import React from 'react';

interface Props {
  titleAccess?: string;
}

export const LoadingDots: React.FC<Props> = ({ titleAccess = 'Lädt' }) => {
  return (
    <>
      <Box sx={visuallyHidden}>{titleAccess}</Box>
      <Dot sx={{ animation: '2000ms ease 0ms infinite normal none running loadingDots' }} />
      <Dot sx={{ animation: '2000ms ease 300ms infinite normal none running loadingDots' }} />
      <Dot sx={{ animation: '2000ms ease 600ms infinite normal none running loadingDots' }} />
    </>
  );
};
